require('./loanSettlementsDetailRow.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ utilities
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
//@commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
//@actions
const LoanSettlementsDetailsActions = require('../../../../actions/loanSettlementsDetails');

class LoanSettlementsDetailRow extends React.Component {
    constructor(props) {
        super(props);

        this.handleRequestData = this.handleRequestData.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        this.handleRequestData();
    }

    buildContent() {
        const hasError = this.props.immTransaction.getIn(['details', 'error']);
        const isLoading = this.props.immTransaction.getIn(['details', 'isFetching']);
        const isEmpty = this.props.immTransaction.getIn(['details', 'details']).isEmpty();
        let content;

        if (hasError) {
            content = this.buildEmptyState('loanSettlementsDetailRow-errorState', true);
        } else if (isLoading) {
            content = (
                <div
                    className="loan-settlements-detail-row__content loan-settlements-detail-row__content--centered"
                >
                    <LoadingSection />
                </div>
            );
        } else if (isEmpty) {
            content = this.buildEmptyState('loanSettlementsDetailRow-emptyState');
        } else {
            content = this.buildTable();
        }

        return content;
    }

    buildEmptyState(messageKey, showButton = false) {
        const primaryText = formatText(messageKey);
        let retryButton;

        if (showButton) {
            retryButton = (
                <OKButton onClick={this.handleRequestData}>
                    <FormattedText value="common-retry" />
                </OKButton>
            );
        }

        return (
            <div className="loan-settlements-detail-row__content loan-settlements-detail-row__content--centered">
                <EmptyState primaryText={primaryText} button={retryButton} iconType="nointernet-banking"/>
            </div>
        );
    }

    buildRows() {
        const immDetails = this.props.immTransaction.getIn(['details', 'details']);

        return immDetails.map((detail, index) => {
            const key = `detail-row-${index}`;
            const detailImport = detail.get('import');
            const plainAmountObject = getPlainAmountObject(detailImport);

            return (
                <OKTableRow key={key}>
                    <OKTableCell>
                        {detail.get('concept')}
                    </OKTableCell>
                    <OKTableCell>
                        {detail.get('startDate')}
                    </OKTableCell>
                    <OKTableCell>
                        {detail.get('endDate')}
                    </OKTableCell>
                    <OKTableCell>
                        {detail.get('rate')}
                    </OKTableCell>
                    <OKTableCell>
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKTableCell>
                </OKTableRow>
            );
        });
    }

    buildTable() {
        const rows = this.buildRows();
        return (
            <div className="loan-settlements-detail-row__content">
                <div className="loan-settlements-detail-row__title">
                    <FormattedText value="loanSettlementsDetailRow-title" />
                </div>
                <OKTable id={this.props.id}>
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlementsDetailRow-concept" format="uppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlementsDetailRow-startDate" format="uppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlementsDetailRow-endDate" format="uppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlementsDetailRow-rate" format="uppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlementsDetailRow-import" format="uppercase" />
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </OKTable>
            </div>
        );
    }

    handleRequestData() {
        const { requestLoanSettlementsDetails, immTransaction } = this.props;
        requestLoanSettlementsDetails(immTransaction.get('loanId'), immTransaction.get('loanSettlementId'));
    }

    render() {
        const content = this.buildContent();

        return (
            <tr className="loan-settlements-detail-row" id={this.props.id}>
                <td colSpan="6">
                    {content}
                </td>
            </tr>
        );
    }
}

LoanSettlementsDetailRow.propTypes = {
    id: PropTypes.string.isRequired,
    immTransaction: PropTypes.object.isRequired,
    requestLoanSettlementsDetails: PropTypes.func.isRequired
};

module.exports = connect(null, {
    requestLoanSettlementsDetails: LoanSettlementsDetailsActions.requestLoanSettlementsDetails
})(LoanSettlementsDetailRow);
